module.exports = __webpack_public_path__ + "static/210-9a6fad32df953229907c98270f29dd02.png";